import { render, staticRenderFns } from "./Cartao.vue?vue&type=template&id=270aa974&"
import script from "./Cartao.vue?vue&type=script&lang=js&"
export * from "./Cartao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports